'use strict';

angular.module('adminDefaultEntitlementControllers')

.controller('BaseFeatureController', ['$scope', '$state', '$stateParams', 'businessSystemService', function ($scope, $state, $stateParams, businessSystemService) {
    $scope.infos.displaySearch = true;

    $scope.systemId = $stateParams.systemId;
    $scope.systemRoleId = $stateParams.systemRoleId;

    businessSystemService.getBusinessSystemForCard($scope.systemId)
                         .then(function (sysInfos) {
                             $scope.system = sysInfos;
                         });

    businessSystemService.getActiveSystemRolesByBusinessSystem($scope.systemId).then(function (systemRoles) {
        var corrSysRoles = _.filter(systemRoles, function (sysRole) {
            return sysRole.SystemRoleID.toString() === $scope.systemRoleId.toString();
        });
        $scope.systemRole = corrSysRoles[0];
    });
}]);
